module.exports = __webpack_public_path__ + "10_mole.cd584c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer2/10_mole.png
// module id = awes
// module chunks = 0